import cookieBar from '../modules/cookieBar'
import {
  lightboxGallery,
  mobileNavigation,
  smoothScroll,
  stickynavigation
} from '../modules/utils'

export default {
  init() {
    cookieBar.init();

    lightboxGallery();
    mobileNavigation();
    smoothScroll();
    stickynavigation();
  },
  finalize() {
  },
};
